import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './ShareBotModal.module.css'
import {
  Button,
  ConfigProvider,
  DatePicker,
  Divider,
  Flex,
  Input,
  message,
  Modal,
  Pagination,
  Popconfirm,
  QRCode,
  Space,
  Switch,
  Table,
  TimePicker,
  Tooltip,
} from 'antd'
import classNames from 'classnames'
import Cookies from 'js-cookie'
import dayjs from 'dayjs'
import { CopyOutlined } from '@ant-design/icons'
import { exportComponentAsPNG } from 'react-component-export-image'
import { HTTP_URL } from '../../../../util/constants'
import {
  getBotShareUrl,
  getBotShareListRequest,
  deleteShareBotRequest,
  changeShareBotStatusRequest,
  changeAllShareBotStatusRequest,
  changeShareBotExpireTimeRequest,
} from './api'
import { clearAllCookies } from '../../../../util/handleObject'
import { copy } from '@testing-library/user-event/dist/cjs/clipboard/copy.js'
export default function ShareBotModal(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const [shareUrl, setShareUrl] = useState('')
  const [downloadShareUrl, setDownloadShareUrl] = useState('')
  const [endTime, setEndTime] = useState('')
  const [endTimeString, setEndTimeString] = useState('')
  const [tableData, setTableData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [total, setTotal] = useState(100) // 假设数据总条数已知或通过API获取

  const componentRef = useRef()

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    setShareUrl('')
    setDownloadShareUrl('')
    setEndTime(dayjs().add(30, 'day'))
    setEndTimeString(dayjs().add(30, 'day').format(dateFormat))
    if (props.visible) {
      getBotShareList(0, pageSize)
    }
    return () => {}
  }, [props.visible]) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  function getBotShareList(offset, limit) {
    getBotShareListRequest(props.info.bot_id, offset, limit, (data) => {
      console.log(data)
      if (data.ret === '1') {
        setTableData(data.data.bot_list)
        setTotal(data.data.total_num)
      } else {
      }
    })
  }
  const getShareUrl = () => {
    if (endTime == '') {
      message.warning('请选择分享截止时间')
      return
    } else if (endTime.valueOf() < today.valueOf()) {
      message.warning('分享截止时间不能早于当前时间')
      return
    }
    let expire_second = endTime.valueOf() - today.valueOf()
    console.log(endTimeString)
    getBotShareUrl(props.info.bot_id, expire_second, endTimeString, (data) => {
      if (data.ret == 1) {
        setShareUrl(data.shareUrl)
        setCurrentPage(1)
        getBotShareList(0, pageSize)
      } else if (data.ret == 99) {
        message.error(data.msg)
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      } else {
        message.error(data.msg)
        setShareUrl('')
      }
    })
  }
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const today = new Date()
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
  const formatter = new Intl.DateTimeFormat('zh-CN', options)
  // var maxDateString = formatter.format(today).replaceAll('/', '-') + ' 23:59'
  var minDateString = formatter.format(today).replaceAll('/', '-') + ' 00:00'

  function doDownload(url, fileName) {
    const a = document.createElement('a')
    a.download = fileName
    a.href = url
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const downloadCanvasQRCode = (idStr) => {
    var scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth
    var scrollBarHeight =
      window.innerHeight - document.documentElement.clientHeight
    exportComponentAsPNG(componentRef, {
      fileName: props.info.bot_name + '二维码.png',
      html2CanvasOptions: {
        scrollX: -scrollBarWidth / 2,
        scrollY: -scrollBarHeight / 2,
      },
    })

    // const canvas = document.getElementById(idStr)?.querySelector('canvas')
    // if (canvas) {
    //   const url = canvas.toDataURL()
    //   doDownload(url, 'QRCode.png')
    // }
  }

  const columns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      align: 'center',
      // width: '96px',
      render: (_, record, index) => (
        <Space size="middle">{(currentPage - 1) * pageSize + index + 1}</Space>
      ),
    },

    {
      title: '可访问截止日期',
      dataIndex: 'expire_time',
      key: 'expire_time',
      align: 'center',
      // width: '96px',
      render: (_, record) => (
        <Space size="middle">
          {/* {_.replace('T', ' ')} */}
          <DatePicker
            style={{ border: 'none' }}
            size="large"
            minDate={dayjs(minDateString, dateFormat)}
            value={dayjs(_)}
            onChange={(date, dateString) => {
              changeShareBotExpireTimeRequest(
                record.short_code,
                props.info.bot_id,
                parseInt((date.valueOf() - today.valueOf()) / 1000),
                (data) => {
                  if (data.ret == 1) {
                    message.success('过期时间更新成功')
                    getBotShareList((currentPage - 1) * pageSize, pageSize)
                  } else if (data.ret == 99) {
                    message.error(data.msg)
                    setTimeout((e) => {
                      sessionStorage.clear()
                      clearAllCookies()
                      window.location.reload()
                    }, 1000)
                  } else {
                    message.error(data.msg)
                  }
                },
              )
            }}
            allowClear={false}
            showTime={true}
          />
        </Space>
      ),
    },

    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (_, record) => (
        <Space size="middle">
          <Switch
            checked={record.status == 1}
            onChange={(checked) => {
              changeShareBotStatusRequest(
                record.short_code,
                checked ? 1 : 0,
                (data) => {
                  if (data.ret == 1) {
                    message.success('状态更新成功')
                    getBotShareList((currentPage - 1) * pageSize, pageSize)
                  } else if (data.ret == 99) {
                    message.error(data.msg)
                    setTimeout((e) => {
                      sessionStorage.clear()
                      clearAllCookies()
                      window.location.reload()
                    }, 1000)
                  } else {
                    message.error(data.msg)
                  }
                },
              )
            }}
            checkedChildren="开"
            unCheckedChildren="关"
            // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}
            style={{ marginLeft: 10, marginRight: 10 }}
          />
        </Space>
      ),
    },
    {
      title: '访问次数',
      dataIndex: 'open_count',
      key: 'open_count',
      align: 'center',
      render: (_, record) => <Space size="middle">{_}</Space>,
    },
    {
      title: '生成时间',
      dataIndex: 'ctime',
      key: 'ctime',
      align: 'center',
      render: (_, record) => <Space size="middle">{_.replace('T', ' ')}</Space>,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      align: 'center',
      render: (_, record) => (
        <Space size="middle">
          <Button
            color="primary"
            variant="link"
            onClick={(e) => {
              if (record.status == 1) {
                setDownloadShareUrl(record.share_url)
                setTimeout(() => {
                  downloadCanvasQRCode('myqrcode')
                  setDownloadShareUrl('')
                }, 100)
              } else {
                message.error('该分享已禁用，无法下载二维码')
              }
            }}
            style={{ padding: 0 }}
          >
            下载
          </Button>
          <Button
            color="primary"
            variant="link"
            onClick={(e) => {
              // setShareUrl(record.share_url)
              // setEndTime(dayjs(record.expire_time))
              if (record.status == 1) {
                copyShareContent(record.share_url)
                // let shareContent =
                //   '家人们谁懂啊！🤯 被【' +
                //   props.info.bot_name +
                //   '】狠狠拿捏了\n不用学不用等，点链接就能解锁\n\n戳这直达➡【' +
                //   record.share_url +
                //   '】\n\n还不快来互动！'
                // navigator.clipboard.writeText(shareContent)
                // message.success('复制成功')
              } else {
                message.error('该分享已禁用，无法复制链接')
              }
              // copy(shareContent)
            }}
            style={{ padding: 0 }}
          >
            复制
          </Button>
          <Popconfirm
            title={'提示'}
            description={'确认删除该分享吗？此操作不可撤销。'}
            okText="确认"
            okType="danger"
            onConfirm={() => {
              deleteShareBotRequest(record.short_code, (data) => {
                if (data.ret == 1) {
                  message.success('删除成功')
                  getBotShareList((currentPage - 1) * pageSize, pageSize)
                } else if (data.ret == 99) {
                  message.error(data.msg)
                  setTimeout((e) => {
                    sessionStorage.clear()
                    clearAllCookies()
                    window.location.reload()
                  }, 1000)
                } else {
                  message.error(data.msg)
                }
              })
            }}
          >
            <Button
              color="danger"
              variant="link"
              onClick={(e) => {}}
              style={{ padding: 0 }}
            >
              删除
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ]
  const handlePageChange = (page, size) => {
    setCurrentPage(page)
    setPageSize(size)
    getBotShareList((page - 1) * size, size)
  }
  const copyShareContent = (share_url) => {
    let shareContent =
      '家人们谁懂啊！🤯 被【' +
      props.info.bot_name +
      '】狠狠拿捏了\n不用学不用等，点链接就能解锁\n\n戳这直达➡【' +
      share_url +
      '】\n\n还不快来互动！'
    navigator.clipboard.writeText(shareContent)
    message.success('复制成功')
  }
  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            /* 这里是你的组件 token */
            contentBg: '#F9FAFB',
            headerBg: '#F9FAFB',
          },
        },
      }}
    >
      <Modal
        title={props.info.bot_name}
        open={props.visible}
        onCancel={() => {
          props.setVisible(false)
        }}
        footer={null}
        width={1000}
      >
        <div className={styles.bigContent}>
          <div className={styles.topContent}>
            <div className={styles.shareContent}>
              <div className={styles.leftContent}>
                <div className={styles.qrContent} ref={componentRef}>
                  <div className={styles.botName}>{props.info.bot_name}</div>
                  {shareUrl == '' && downloadShareUrl == '' ? (
                    <img
                      src={require('./qr.png')}
                      style={{ width: 110 }}
                      alt="qr"
                    />
                  ) : (
                    <QRCode
                      id="myqrcode"
                      value={
                        downloadShareUrl == '' ? shareUrl : downloadShareUrl
                      }
                      size={110}
                    />
                  )}
                </div>
                <Button
                  style={{ marginTop: 30 }}
                  onClick={() => {
                    downloadCanvasQRCode('myqrcode')
                  }}
                >
                  下载二维码
                </Button>
              </div>
              <div className={styles.rightContent}>
                <div className={styles.titleContent}>
                  <h1 className={styles.title}>智能体分享码</h1>
                  {/* <div className={styles.buttonStyle} onClick={getShareUrl}>
                生成
              </div> */}
                </div>

                <div className={styles.content}>
                  <Input
                    size="large"
                    value={shareUrl}
                    placeholder="分享网址"
                    suffix={
                      <CopyOutlined
                        style={{ color: 'rgba(0,0,0,0.3)' }}
                        onClick={() => {
                          if (shareUrl == '') {
                            message.warning('请先生成分享码')
                            return
                          }
                          copyShareContent(shareUrl)
                          // navigator.clipboard.writeText(shareUrl)
                          // message.success('复制成功')
                        }}
                      />
                    }
                  />
                  <DatePicker
                    style={{ width: '100%', marginTop: 30 }}
                    size="large"
                    minDate={dayjs(minDateString, dateFormat)}
                    value={endTime ? dayjs(endTime) : null}
                    onChange={(date, dateString) => {
                      setEndTime(date)
                      console.log(dateString)
                      setEndTimeString(dateString)
                      console.log(endTimeString)
                    }}
                    showTime={true}
                    allowClear={false}
                  />
                  <div className={styles.tip}>可访问截止日期</div>
                </div>
              </div>
            </div>
            <div
              className={styles.buttonStyle}
              style={{ marginTop: 40,width:'100px' }}
              type="primary"
              onClick={() => {
                getShareUrl()
              }}
            >
              生成智能体分享
            </div>
          </div>
          <div className={styles.tableHeader}>
            <div className={styles.tableTitle}>历史生成分享记录</div>
            <Button
              type="primary"
              onClick={() => {
                changeAllShareBotStatusRequest(props.info.bot_id, 0, (data) => {
                  if (data.ret == 1) {
                    message.success('禁用成功')
                    getBotShareList((currentPage - 1) * pageSize, pageSize)
                  } else if (data.ret == 99) {
                    message.error(data.msg)
                    setTimeout((e) => {
                      sessionStorage.clear()
                      clearAllCookies()
                      window.location.reload()
                    }, 1000)
                  } else {
                    message.error(data.msg)
                  }
                })
              }}
            >
              全部禁用
            </Button>
          </div>
          <Table
            columns={columns}
            dataSource={tableData}
            // pagination={{
            //     current: currentPage, // 当前页码
            //     pageSize: pageSize, // 每页条数
            //     total: total, // 数据总条数
            //     onChange: handlePageChange, // 分页改变时的回调函数
            //     showSizeChanger: true, // 是否显示每页条数改变的选项
            //     // showQuickJumper: true, // 是否可以快速跳转到指定页
            //     // showTotal: (total) => `共 ${total} 条数据`, // 显示数据总量的函数
            //     hideOnSinglePage:false
            // }}
            pagination={false}
            bordered
            // scroll={{
            //     x: 'max-content',
            //     y: 55 * 5,
            // }}
            tableLayout="auto"
            style={{ minWidth: '100%', marginTop: 20,backgroundColor:'white',padding:'20px',borderRadius:'8px' }}
          />
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={total}
            onChange={handlePageChange}
            showSizeChanger={true}
            hideOnSinglePage={false}
            align="end"
            style={{ marginTop: 20 }}
          />
        </div>
      </Modal>
    </ConfigProvider>
  )
}
